import * as React from "react";

class DataCompliance extends React.Component<{}, {}> {
    render = () => {
        return (
            <div className="container-fluid">
                <div className="row">
                    <div className="col-xs-12">
                        Coming soon...
                    </div>
                </div>
            </div>
        )
    }
}

export default DataCompliance;